enum SituacoesVendaItem {
    Orcamento = 0,
    Rejeitado = 1,
    Aprovado = 2,
    Cancelado = 3,
    Concluido = 4
}

export default SituacoesVendaItem;